import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, isRef as _isRef, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6969abfa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-video" }
const _hoisted_2 = { class: "home-video-box" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "btn-list" }
const _hoisted_5 = { class: "box" }
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src"]
const _hoisted_10 = ["src"]
const _hoisted_11 = ["src"]
const _hoisted_12 = ["src"]
const _hoisted_13 = ["src"]
const _hoisted_14 = ["src"]
const _hoisted_15 = ["src"]
const _hoisted_16 = ["src"]
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "download" }
const _hoisted_19 = ["src"]
const _hoisted_20 = { class: "platform" }
const _hoisted_21 = ["href"]
const _hoisted_22 = ["src"]
const _hoisted_23 = ["src"]
const _hoisted_24 = ["href"]
const _hoisted_25 = ["src"]
const _hoisted_26 = ["src"]
const _hoisted_27 = { class: "age-12" }
const _hoisted_28 = ["src"]

import { ref } from "vue";
import _ from "lodash-es";
import { GlobalState } from "@/pages/index/store";
import { buriedPoint } from "@/api/indexPC";
import { useStore } from "vuex";

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const store = useStore<GlobalState>();

// 头部按钮词典
let btnDict: { [index: string]: string } = {
  0: "prosperity",
  1: "home_info",
  2: "ancient_city",
  3: "game_features",
  4: "gaming_community",
};

// 移动到对应的板块
function movePlate(index: number) {
  console.log(btnDict[index]);
  const el = document.getElementById(btnDict[index]);
  if (index !== 0) {
    window.scrollTo({
      top: el?.children[0].getBoundingClientRect().top,
      behavior: "smooth",
    });
  }
}

let videoFlag = ref(false);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "prosperity",
    id: "prosperity",
    style: _normalizeStyle({
      backgroundImage: 'url(' + _unref(store)?.state?.prosperityObj?.kv_img + ')',
    })
  }, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("iframe", {
          src: _unref(videoFlag) ? _unref(store)?.state?.imageObj?.KVico?.paly?.move : '',
          scrolling: "no",
          border: "0",
          frameborder: "no",
          framespacing: "0",
          allowfullscreen: "true"
        }, "\n        ", 8, _hoisted_3),
        _createElementVNode("a", {
          href: "javascript:;",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_isRef(videoFlag) //@ts-ignore
 ? videoFlag.value = !_unref(videoFlag) : videoFlag = !_unref(videoFlag))),
          class: "home-video-close"
        }, "×")
      ])
    ], 512), [
      [_vShow, _unref(videoFlag)]
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", {
          class: "btn-item hover",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (movePlate(0)))
        }, [
          _createElementVNode("img", {
            src: _unref(store)?.state?.imageObj?.nav?.index?.a,
            alt: "首页"
          }, null, 8, _hoisted_6),
          _createElementVNode("img", {
            src: _unref(store)?.state?.imageObj?.nav?.index?.hover,
            alt: "首页"
          }, null, 8, _hoisted_7)
        ]),
        _createElementVNode("div", {
          class: "btn-item hover",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (movePlate(1)))
        }, [
          _createElementVNode("img", {
            src: _unref(store)?.state?.imageObj?.nav?.new?.a,
            alt: "画唐咨询"
          }, null, 8, _hoisted_8),
          _createElementVNode("img", {
            src: _unref(store)?.state?.imageObj?.nav?.new?.hover,
            alt: "画唐咨询"
          }, null, 8, _hoisted_9)
        ]),
        _createElementVNode("div", {
          class: "btn-item hover",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (movePlate(2)))
        }, [
          _createElementVNode("img", {
            src: _unref(store)?.state?.imageObj?.nav?.scenery?.a,
            alt: "古城风光"
          }, null, 8, _hoisted_10),
          _createElementVNode("img", {
            src: _unref(store)?.state?.imageObj?.nav?.scenery?.hover,
            alt: "古城风光"
          }, null, 8, _hoisted_11)
        ]),
        _createElementVNode("div", {
          class: "btn-item hover",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (movePlate(3)))
        }, [
          _createElementVNode("img", {
            src: _unref(store)?.state?.imageObj?.nav?.feature?.a,
            alt: "游戏特色"
          }, null, 8, _hoisted_12),
          _createElementVNode("img", {
            src: _unref(store)?.state?.imageObj?.nav?.feature?.hover,
            alt: "游戏特色"
          }, null, 8, _hoisted_13)
        ]),
        _createElementVNode("div", {
          class: "btn-item hover",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (movePlate(4)))
        }, [
          _createElementVNode("img", {
            src: _unref(store)?.state?.imageObj?.nav?.bbs?.a,
            alt: "游戏社区"
          }, null, 8, _hoisted_14),
          _createElementVNode("img", {
            src: _unref(store)?.state?.imageObj?.nav?.bbs?.hover,
            alt: "游戏社区"
          }, null, 8, _hoisted_15)
        ])
      ])
    ]),
    _createElementVNode("div", {
      class: "play-btn hover",
      onClick: _cache[6] || (_cache[6] = ($event: any) => (_isRef(videoFlag) //@ts-ignore
 ? videoFlag.value = !_unref(videoFlag) : videoFlag = !_unref(videoFlag)))
    }, [
      _createElementVNode("img", {
        src: _unref(store)?.state?.imageObj?.KVico?.paly?.a
      }, null, 8, _hoisted_16),
      _createElementVNode("img", {
        src: _unref(store)?.state?.imageObj?.KVico?.paly?.hover
      }, null, 8, _hoisted_17)
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", {
        class: "qrcode-box",
        style: _normalizeStyle({
          backgroundImage:
            'url(' + _unref(store)?.state?.imageObj?.KVico?.ewm?.border + ')',
        })
      }, [
        _createElementVNode("img", {
          alt: "下载二维码",
          src: _unref(store)?.state?.imageObj?.KVico?.ewm?.code
        }, null, 8, _hoisted_19)
      ], 4),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("a", {
          class: "ios hover",
          href: _unref(store)?.state?.imageObj?.KVico?.android?.url,
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_unref(buriedPoint)('ios下载按钮', 1)))
        }, [
          _createElementVNode("img", {
            src: _unref(store)?.state?.imageObj?.KVico?.android?.a
          }, null, 8, _hoisted_22),
          _createElementVNode("img", {
            src: _unref(store)?.state?.imageObj?.KVico?.android?.hover
          }, null, 8, _hoisted_23)
        ], 8, _hoisted_21),
        _createElementVNode("a", {
          class: "android hover",
          href: _unref(store)?.state?.imageObj?.KVico?.ios?.url,
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_unref(buriedPoint)('安卓下载按钮', 1)))
        }, [
          _createElementVNode("img", {
            src: _unref(store)?.state?.imageObj?.KVico?.ios?.a
          }, null, 8, _hoisted_25),
          _createElementVNode("img", {
            src: _unref(store)?.state?.imageObj?.KVico?.ios?.hover
          }, null, 8, _hoisted_26)
        ], 8, _hoisted_24)
      ]),
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("img", {
          src: require('@/assets/img/index/12+.png'),
          alt: "12"
        }, null, 8, _hoisted_28)
      ])
    ])
  ], 4))
}
}

})